import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface SpinnerProps {
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const getIconSizeClassName = (size: SpinnerProps["size"]) => {
  switch (size) {
    case "sm":
      return "w-4 h-4";
    case "lg":
      return "w-8 h-8";
    default:
      return "w-6 h-6";
  }
};

export default function Spinner({
  label,
  className,
  size = "md",
}: SpinnerProps) {
  const textSizeClassName = `text-${size}`;
  const iconSizeClassName = getIconSizeClassName(size);
  return (
    <div
      className={cn(
        "flex flex-row items-center justify-center text-lg",
        textSizeClassName,
        className,
      )}
    >
      <Loader2 className={cn("mr-2 animate-spin", iconSizeClassName)} />
      {label}
    </div>
  );
}
